export default __webpack_public_path__ + "static/empg-logo-5598504d526acc9652121794e37f6b69.png";